import api from '../api';

import { ParamsServicesPlatforms } from 'utils/typeServices';

type ParamsReponse = {
    Data: {
        ServicosPlataformas: Array<ParamsServicesPlatforms>;
    }
}

export const GetInitialServicesHome = async ({ token }: { token: string }) => {
    try {
        const { data } = await api.get<ParamsReponse>('v2/Plataforma/ListarServicosPlataformaUsuario', {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });

        return { data: data.Data };
    } catch (error) {
        console.error('error', error);
        return { data: null };
    }
}
